module.exports = __webpack_public_path__ + "static/media/01n.69c2e7eb.svg";